/**
*****************************************
*                                       *
* NAGARRO  - CSX - CONFIDENTIAL         *
*                                       *
*****************************************
*/
import { RouterModule, Routes } from '@angular/router';
import { CanDeactivateViaEditGuardService } from './../core/services/can-deactivate-via-edit-guard.service';
import { LmsLocoComponent } from './loco.component';
import { LmsLocoDataComponent } from './data/loco-data.component';
import { LmsLocoHistoryComponent } from './history/loco-history.component';
import { LmsLocoNotesComponent } from './notes/loco-notes.component';
import { LocoDataResolver } from './shared/loco-data.resolver';
import { LocoHistoryResolver } from './shared/loco-history.resolver';
import { LocoNotesResolver } from './shared/loco-notes.resolver';
import { NgModule } from '@angular/core';

const locoRoutes: Routes = [
    {
        path: 'locomotive',
        component: LmsLocoComponent,
        data: { tab: 'Locomotive' },
        children: [
            {
                path: 'data',
                component: LmsLocoDataComponent,
                data: { tab: 'Locomotive' },
                resolve: {
                    tabData: LocoDataResolver
                },
                canDeactivate: [CanDeactivateViaEditGuardService]
            },
            {
                path: 'data/:tabid',
                component: LmsLocoDataComponent,
                data: { tab: 'Locomotive' },
                resolve: {
                    tabData: LocoDataResolver
                },
                canDeactivate: [CanDeactivateViaEditGuardService]
            },
            {
                path: 'data/:tabid/:search',
                component: LmsLocoDataComponent,
                data: { tab: 'Locomotive' },
                resolve: {
                    tabData: LocoDataResolver
                },
                canDeactivate: [CanDeactivateViaEditGuardService]
            },
            {
                path: 'history',
                component: LmsLocoHistoryComponent,
                data: { tab: 'Locomotive' },
                resolve: {
                    tabData: LocoHistoryResolver
                },
                // canDeactivate: [CanDeactivateViaEditGuardService]
            },
            {
                path: 'history/:tabid',
                component: LmsLocoHistoryComponent,
                data: { tab: 'Locomotive' },
                resolve: {
                    tabData: LocoHistoryResolver
                },
                // canDeactivate: [CanDeactivateViaEditGuardService]
            },
            {
                path: 'history/:tabid/:search',
                component: LmsLocoHistoryComponent,
                data: { tab: 'Locomotive' },
                resolve: {
                    tabData: LocoHistoryResolver
                },
                // canDeactivate: [CanDeactivateViaEditGuardService]
            },
            {
                path: 'notes',
                component: LmsLocoNotesComponent,
                data: { tab: 'Locomotive' },
                resolve: {
                    tabData: LocoNotesResolver
                },
                canDeactivate: [CanDeactivateViaEditGuardService]
            },
            {
                path: 'notes/:tabid',
                component: LmsLocoNotesComponent,
                data: { tab: 'Locomotive' },
                resolve: {
                    tabData: LocoNotesResolver
                },
                canDeactivate: [CanDeactivateViaEditGuardService]
            }
        ]
    }
];

/**
 * @export
 * @class LocoRoutingModule
 */
@NgModule({
    imports: [
        RouterModule.forChild(locoRoutes)
    ],
    exports: [
        RouterModule
    ]
})
export class LocoRoutingModule {

}
